import { memo, useCallback } from "react";
import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { TransactionListItem } from "@common/schemas/transaction.schema";
import { Button } from "@design-system/Button/Button";
import { getTransactionsTableMeta } from "@hooks/view/useViewTableMeta";
import { CheckIcon, EllipseIcon } from "@icons";
import styles from "./ReviewCell.module.scss";

export const ReviewCell = memo(
    ({
        row,
        table,
    }: CellContext<ViewTableFeatures, TransactionListItem, unknown>) => {
        const meta = getTransactionsTableMeta(table);
        const onOpenTransactionReview = meta.callbacks?.onOpenTransactionReview;
        const isReadonly = meta.options?.readonly ?? false;
        const hasReviews = (row.original.fieldReviews?.length ?? 0) > 0;

        const handleClick = useCallback(
            (e: React.MouseEvent) => {
                e.stopPropagation();
                onOpenTransactionReview?.(row.original.id);
            },
            [onOpenTransactionReview, row.original.id],
        );

        return (
            <div className={styles.wrapper}>
                <Button
                    variant="secondary"
                    size="sm"
                    iconOnly
                    disabled={isReadonly}
                    onClick={handleClick}
                    aria-label={
                        hasReviews ? "View field reviews" : "Review fields"
                    }
                >
                    {hasReviews ? <CheckIcon /> : <EllipseIcon />}
                </Button>
            </div>
        );
    },
);

ReviewCell.displayName = "ReviewCell";
